import { Category } from '@design/components/side-navigation';

export const sidebarKeys = {
  alfred: 'alfred',
  expMobileAlfred: 'expMobileAlfred',
  settings: 'settings',
  screener: 'screener',
  watchlist: 'watchlist',
  quickAnalysis: 'quickAnalysis',
  research: 'research',
  document: 'document',
  insightFeed: 'stream',
};

const pathMatcher = (pathname: string, regexp?: RegExp) =>
  regexp?.test(pathname);

export const getActiveNavigationKey = (
  categories: Category,
  pathname: string = location?.pathname
) => {
  const subItems = categories.items;

  return subItems.find(item => {
    const isPath = item.key.startsWith('/');
    return isPath && pathMatcher(pathname, new RegExp(item.key));
  })?.key;
};
